import React from 'react'

export default function Casestudies() {
  return (
    <section data-aos="fade-up">Casestudies</section>
  )
}
